import { render, staticRenderFns } from "./FuelsChip.vue?vue&type=template&id=3883724a&"
import script from "./FuelsChip.vue?vue&type=script&lang=js&"
export * from "./FuelsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports